module.exports = __webpack_public_path__ + "img/sllr-icon.c86cce1f.svg";